<mat-menu #tositeMenu="matMenu">
  <ng-template matMenuContent let-tosite="tosite" let-naytettavaKirjaus="naytettavaKirjaus" let-onkoLuottokorttilaskuKirjauksia="onkoLuottokorttilaskuKirjauksia">
    <app-menu-item-button (click)="tositeTositeUudessaIkkunassa(tosite)" actionId="Avaa tosite uudessa ikkunassa">Avaa uudessa ikkunassa</app-menu-item-button>
    <app-menu-item-button [disabled]="tosite.avain === naytettavaKirjaus?.kirjaus?.avain" (click)="irroitaTositeHandler(tosite)" actionId="Irroita tosite kirjauksesta">Irroita tosite kirjauksesta</app-menu-item-button>
    <app-menu-item-button (click)="kopioiTositeHandler(tosite)" actionId="Kopioi tosite">Kopioi tosite</app-menu-item-button>
    <app-menu-item-button (click)="lataaTositeHandler(tosite)" actionId="Lataa tosite">Lataa tosite</app-menu-item-button>
    <app-menu-item-button (click)="tallennaHallintokansioonHandler(tosite)" actionId="Tallenna tosite hallintokansioon">Tallenna hallintokansioon</app-menu-item-button>
    @if (onkoDevaajaTaiItTukiTaiMuut | async) {
      <app-menu-item-button (click)="teeLuottokorttilaskustaKirjauksetHandler(tosite)" actionId="Tee luottokorttilaskusta kirjaukset">Tee luottokorttilaskusta kirjaukset</app-menu-item-button>
      @if (onkoLuottokorttilaskuKirjauksia) {
        <app-menu-item-button (click)="poistaLuottokorttilaskunLuomatKirjauksetHandler(tosite)" actionId="Poista luottokorttilaskun luomat kirjaukset">Poista tositteesta luodut kirjaukset</app-menu-item-button>
      }
    }
  </ng-template>
</mat-menu>

@for (tosite of naytettavatTositteetJaSivutObservable | async; track trackbyTosite(tositeIndex, tosite); let tositeIndex = $index) {
  <div class="naytettava-tosite" [class.esikatselu]="naytaRuksi" draggable="true">
    <!-- TOSITE -->
    <!-- {{ time() }} -->
    @if (!piilotaYlaControllit) {
      <div style="display: flex; justify-content: space-between">
        @if ({ naytettavaKirjaus: (naytettavaKirjausObservable | async) }; as subscribed) {
          <div>
            @if (!tosite.tallennetaan && !tosite.poistetaan && !naytaRuksi) {
              <app-icon-button [matMenuTrigger]="tositeMenu" [matMenuTriggerData]="{ tosite: tosite, naytettavaKirjaus: subscribed.naytettavaKirjaus, onkoLuottokorttilaskuKirjauksia: (onkoLuottokorttilaskuKirjauksetObservable(tosite) | async) }" (click)="$event.stopPropagation()" actionId="Avaa tosite menu" styles="margin-left: -10px;" matIcon="more_vert"> </app-icon-button>
            }
            @if (naytaRuksi && subscribed.naytettavaKirjaus) {
              <app-button (click)="liitaValittuunKirjauksen(tosite)" actionId="Liitä tosite valittuun kirjaukseen" styles="line-height: 40px; padding-left: 0; font-size: 16px;" matIcon="attach_file"> Liitä valittuun kirjaukseen </app-button>
            }
          </div>
        }
        @if (tosite.kuittiTekstiPromise) {
          <div style="flex-grow: 1; padding-top: 10px; padding-bottom: 10px">
            @if (tosite.kuittiTekstiPromise | async; as kuittiTeksti) {
              {{ kuittiTeksti }}
            } @else {
              <mat-progress-bar [@fadeInAnimation]="'in'" mode="indeterminate" style="margin-top: 8px; margin-left: 5px; margin-right: 10px; width: calc(100% - 20px)"></mat-progress-bar>
            }
          </div>
        }
        @if (tosite.luottotappio) {
          <div style="flex-grow: 1; padding-top: 10px; padding-bottom: 10px" class="red-text">Laskun avoinna oleva summa on merkitty luottotappioksi!</div>
        }
        @if (naytaRuksi) {
          <app-icon-button (click)="ruksiaPainettu(tosite)" actionId="Tosite näyttö: ruksia painettu" styles="margin-right: -10px; font-size: 22px;"> X </app-icon-button>
        }
        @if (!naytaRuksi) {
          <div style="margin-right: 2px; font-size: 16px; line-height: 40px; white-space: nowrap">Tosite {{ tositeIndex + 1 }}/{{ naytettavatTositteetJaSivut.length }}</div>
        }
      </div>
    } @else {
      <div>&nbsp;</div>
    }
    @if (tosite.tallennetaan) {
      <div [@fadeInAnimation]="'in'" style="text-align: center; margin: 30px">
        <span style="display: inline-block; margin-bottom: 15px">Tositetta tallennetaan</span>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
    <!-- {{ tosite.lahde }} -->
    <!-- SIVUT -->
    @for (sivu of tosite.sivut; track trackBySivu(sivuIndex, sivu); let sivuIndex = $index) {
      <div #sivu [id]="sivu.avain" class="tositteen-sivu">
        <div class="image-manipulation-tools">
          @if (sivu.zoomable) {
            <app-icon-button (click)="zoomOut(sivu)" actionId="Tosite näyttö: zoomaa ulos">
              <i class="fa fa-search-minus"></i>
            </app-icon-button>
          }
          @if (sivu.zoomable) {
            <app-icon-button (click)="zoomIn(sivu)" actionId="Tosite näyttö: zoomaa sisään">
              <i class="fa fa-search-plus"></i>
            </app-icon-button>
          }
          @if (sivu.rotatable) {
            <app-icon-button (click)="rotateRight(sivu)" actionId="Tosite näyttö: kierrä">
              <i class="fa fa-repeat"></i>
            </app-icon-button>
          }
          @if (sivu.urlEnhanced) {
            <app-icon-button [dynamicClass]="{ enhancingOn: !!sivu.useEnhancedUrl }" (click)="enhance(sivu)" actionId="Tosite näyttö: paranna">
              <i class="fa fa-magic"></i>
            </app-icon-button>
          }
        </div>
        <div class="page-number">sivu {{ sivuIndex + 1 }}/{{ tosite.sivut.length }}</div>
        @if (sivu.type == 'lasku') {
          <div app-lasku-pdf-esikatselu-perinteinen-rajoitettu-leveyteen [@fastFadeInOutAnimation]="'in'" [tiedot]="sivu.esikatselutiedot"></div>
        }
        <!-- (click)="sivuaKlikattiin($event, naytettavatTositteetJaSivut, tosite, sivu)" -->
        <!-- </div> -->
        <!-- draggable="true" (dragstart)="aloitaRaahaaminen($event)" (dragend)="lopetaRaahaaminen($event)" -->
        <!-- [style.visibility]="(ladataanKuvaaObservable | async) ? 'hidden' : 'visible'" -->
        @if (sivu.type == 'kuitti') {
          <!-- KUITTI -->
          @if (sivu.ladataan) {
            <div [@fadeInAnimation]="'in'" style="text-align: center; margin: 60px 30px 0; position: absolute; top: 30px; left: 0; right: 0">
              <span style="display: inline-block; margin-bottom: 15px">Ladataan tositteen sivua</span>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          @if (sivu.virhe) {
            <div [@fastFadeInOutAnimation]="'in'" style="text-align: center; margin: 60px 30px 0; position: absolute; top: 30px; left: 0; right: 0">
              <div>
                Kuvan latauksessa tapahtui virhe.
                <!-- <button mat-button (click)="lataaUudelleen()">Yritä lataamista uudelleen napauttamalla tätä.</button> -->
              </div>
            </div>
          }
          <div
            app-image-viewer
            [@fastFadeInOutAnimation]="'in'"
            [parentScrollContainer]="scrollContainerRef"
            [class.tositteen-sivua-ladataan]="sivu.ladataan"
            [class.tositteen-sivu-latausvirhe]="sivu.virhe"
            [rotateDegrees]="sivu.rotationDegrees"
            [url]="sivu.useEnhancedUrl ? sivu.urlEnhanced : sivu.url"
            [(zoomMultiplier)]="sivu.zoomMultiplier"
            (imageLoadComplete)="sivunLatausValmis($event, sivu)"
            (imageLoadError)="sivunLatausVirhe($event, sivu)"
          ></div>
        }
        <!-- (click)="sivuaKlikattiin($event, naytettavatTositteetJaSivut, tosite, sivu)" -->
        @if (sivu.type == 'kuitti-async') {
          @if (sivu.ladataan) {
            <div [@fadeInAnimation]="'in'" style="text-align: center; margin: 60px 30px 0; position: absolute; top: 30px; left: 0; right: 0">
              <span style="display: inline-block; margin-bottom: 15px">Ladataan tositteen sivua</span>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          @if (sivu.virhe) {
            <div [@fastFadeInOutAnimation]="'in'" style="text-align: center; margin: 60px 30px 0; position: absolute; top: 30px; left: 0; right: 0">
              <div>
                Kuvan latauksessa tapahtui virhe.
                <!-- <button mat-button (click)="lataaUudelleen()">Yritä lataamista uudelleen napauttamalla tätä.</button> -->
              </div>
            </div>
          }
          <!-- ASYNC -->
          @if (sivu.ulrPromise | async; as url) {
            <div
              app-image-viewer
              [@fastFadeInOutAnimation]="'in'"
              [parentScrollContainer]="scrollContainerRef"
              [class.tositteen-sivua-ladataan]="sivu.ladataan"
              [class.tositteen-sivu-latausvirhe]="sivu.virhe"
              [rotateDegrees]="sivu.rotationDegrees"
              [url]="url"
              [(zoomMultiplier)]="sivu.zoomMultiplier"
              (imageLoadComplete)="sivunLatausValmis($event, sivu)"
              (imageLoadError)="sivunLatausVirhe($event, sivu)"
            ></div>
          }
        }
        <!-- (click)="sivuaKlikattiin($event, naytettavatTositteetJaSivut, tosite, sivu)" -->
        <!-- <div  app-pdf-viewer [url]="safeUrl" [zoomMultiplier]="zoomMultiplier" [kuvienTargetWidth]="kuvienTargetWidth" [style.visibility]="(ladataanPdfaObservable | async) ? 'hidden' : 'visible'" (pdfLoadComplete)="pdfnLatausOnValmis($event)" draggable="true"
      (dragstart)="aloitaRaahaaminen($event)" (dragend)="lopetaRaahaaminen($event)" style="text-align: center; position: absolute; left: 0; right: 0; top: 0; bottom: 0; overflow: auto; padding-top: 40px;">
    </div> -->
        @if (sivu.type == 'pdf') {
          <!-- PDF -->
          @if (sivu.ladataan) {
            <div [@fadeInAnimation]="'in'" style="text-align: center; margin: 60px 30px 0; position: absolute; top: 30px; left: 0; right: 0">
              <span style="display: inline-block; margin-bottom: 15px">Ladataan tositteen sivua</span>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          <div app-pdf-viewer [@fastFadeInOutAnimation]="'in'" [class.tositteen-sivua-ladataan]="sivu.ladataan" [class.tositteen-sivu-latausvirhe]="sivu.virhe" [rotateDegrees]="sivu.rotationDegrees" [url]="sivu.url" [zoomMultiplier]="sivu.zoomMultiplier" (pdfLoadComplete)="sivunLatausValmis($event, sivu)"></div>
        }
      </div>
    }
    <!-- </ng-container> -->
  </div>
}
